import { INTERNET_DELAY } from "@/constants";

export const updateNewFetchDuration = (systemTimestamp: number,nowDate:number) => {
  let localDelay = window.localStorage.getItem(INTERNET_DELAY);
  if (!localDelay) localDelay = "100000";
  const serverNow = systemTimestamp * 1000;
  const delay = serverNow - nowDate;
  if (delay < Number(localDelay) || delay < Number(localDelay)) { 
    window.localStorage.setItem(INTERNET_DELAY, String(delay));
  }
};
